<template>
    <el-dialog :title="title" :visible.sync="dialogVisible" width="30%" :before-close="handleClose"
        :close-on-click-modal="false" :close-on-press-escape="false">
        <div class="text-center">
            <el-progress type="circle" :percentage="percentage"></el-progress>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" :loading="loadding" @click="yes()">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import $updateload from "@/mixins/updateload.js";
export default {
    mixins: [$updateload],
    data() {
        return {
            title: "出现新版本",
            dialogVisible: false,
            loadding: false,
            percentage: 0,
            versionInfo: {},
            url: {
                getdownloadupdatekey: "/toolaccount/getdownloadupdatekey",
                unlockdownloadupdatekey: "/toolaccount/unlockdownloadupdatekey",
            },
        }
    },
    created() {

    },
    methods: {
        getdownloadupdatekey: function () {
            return this.$api.post(this.url.getdownloadupdatekey, {});
        },
        unlockdownloadupdatekey: function (key) {
            return this.$api.post(this.url.unlockdownloadupdatekey, { key: key });
        },
        show: function (info) {
            this.getdownloadupdatekey().then(rs => {
                if (rs.code == 1) {
                    //判断key
                    this.setKey(rs.info.key);
                    //看下要不要下载更新
                    this.title = `发现新版本:${info.version}`;
                    this.versionInfo = info;
                    this.percentage = 0;
                    this.loadding = false;
                    this.dialogVisible = true;
                }

            });
        },
        finishDonwload: function () {
            //下载完毕
            this.percentage = 100;
            this.loadding = false;
            this.$store.dispatch('updateload/getKey').then(key => {
                //删除key
                this.unlockdownloadupdatekey(key);
                this.$call.sendSync("winEvent.quitAndInstall");
            });
        },
        updatePercentage: function (percentage) {
            this.percentage = parseFloat(percentage.percent.toFixed(2));
            // console.log("下载进度", percentage);
        },
        yes: function () {
            this.loadding = true;
            this.$call.sendSync("winEvent.downloadUpdate");
        },
        handleClose: function () {
            this.dialogVisible = false;
        },
    }
}
</script>